import { Inline, Schema } from '@gitbook/slate';

import { INLINE_ICON, type InlineIconData, LEAF_RICH_BLOCKS } from '../types';

export const schema = Schema.create({
    inlines: {
        [INLINE_ICON]: {
            isVoid: true,
            parent: { types: LEAF_RICH_BLOCKS },
            data: {
                icon: (icon) => typeof icon === 'string',
                color: (color) => color === undefined || typeof color === 'string',
            },
        },
    },
});

export function createIcon(icon: string, color?: InlineIconData['color']): Inline {
    return Inline.createVoid({
        type: INLINE_ICON,
        data: {
            icon,
            ...(color ? { color } : {}),
        },
    });
}
